<span style="margin-left: 4px; color: var(--blue-grey-500)" (click)="showDialog()"
  ><i
    class="fa fa-question-circle fa-lg"
    tooltipStyleClass="xtooltip"
    pTooltip="View availability status information"
  ></i
></span>

<p-dialog
  header="Availability Statuses"
  [(visible)]="dialogVisible"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '550px' }"
  (visibleChange)="onVisibilityChanged($event)"
>
  <div class="dialog-content">
    <div class="main-header">Overview</div>
    <ul>
      <li>
        To manage your availability, click on a date to cycle through: Available, Unavailable and Do
        Not Disturb.
      </li>
      <li>Click a day header to set availability for all matching weekdays</li>
      <li>Select multiple days to apply an availability state across the selection</li>
      <li>Dates marked as 'Unset' mean you may not be notified of suitable jobs</li>
    </ul>

    <div class="main-header">How the Statuses Work</div>
    <div class="sub-header">There are 4 possible statuses that you can set on a given day:</div>

    <div class="status-list">
      <div class="status-item">
        <div class="status-header unset">Unset Priority</div>
        <div class="status-text">
          This status displays if your availability is unknown meaning you may not be notified of
          suitable jobs.
        </div>
      </div>

      <div class="status-item">
        <div class="status-header available">Available</div>
        <div class="status-text">
          Select this option if you are able to work and would like to be contacted by the Engineius
          team about jobs.
        </div>
      </div>

      <div class="status-item">
        <div class="status-header unavailable">Unavailable</div>
        <div class="status-text">
          Select this option if you are not able to work, but can still be contacted by the
          Engineius team about jobs.
        </div>
      </div>

      <div class="status-item">
        <div class="status-header do-not-disturb">
          <span> <i class="fa fa-minus-circle"></i>&nbsp;Do Not Disturb </span>
        </div>
        <div class="status-text">
          Select this option if you are not able to work and you do not want contacted by the
          Engineius team about jobs.
        </div>
      </div>
    </div>
  </div>
</p-dialog>
